export default "__VITE_ASSET__C4w1fpwp__"